module.exports = __webpack_public_path__ + "static/img/bg-ar.383ad139.png";